import { ComponentProps } from 'react';

import { MergeVariantProps } from '../cva';
import { LinkVariantProps, linkVariants } from './variants';

export type LinkProps = MergeVariantProps<
    ComponentProps<'a'>,
    LinkVariantProps
>;

export function Link(props: LinkProps) {
    return <a {...props} className={linkVariants(props)} />;
}
